





































import Vue from 'vue'
import sortBy from 'lodash/sortBy'
import groupBy from 'lodash/groupBy'
import { BrandModel } from '@/common/types/brands'
import { SVG_PLACEHOLDER_IMAGES, IMAGE_VARIANT_NAMES } from '@/common/constants'
import BaseImage from '@/common/components/BaseImage.vue'

export default Vue.extend({
  components: {
    BaseImage
  },
  props: {
    brands: {
      type: Array as () => BrandModel[],
      default: () => []
    }
  },
  computed: {
    IMAGE_VARIANT_NAMES() {
      return IMAGE_VARIANT_NAMES
    },
    placeholder(): string {
      return SVG_PLACEHOLDER_IMAGES.BRAND_LOGO
    },
    displayedBrands(): Record<string, BrandModel[]> {
      return groupBy(
        sortBy(
          this.brands.map(item => ({
            ...item,
            group: item.brandName.charAt(0).toUpperCase()
          })),
          'group'
        ),
        'group'
      )
    }
  }
})
